"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePresets = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var layout_1 = require("../../layout");
var Text_1 = __importDefault(require("../../Text"));
var style_1 = require("../../../style");
var styles_1 = require("./styles");
var utils_1 = require("./utils");
var variables_1 = require("../../../style/variables");
exports.DatePresets = {
    TODAY: { label: 'Today', startDate: utils_1.selectToday(), endDate: utils_1.selectToday() },
    YESTERDAY: { label: 'Yesterday', startDate: utils_1.selectYesterday(), endDate: utils_1.selectYesterday() },
    THIS_WEEK: { label: 'This week', startDate: utils_1.selectThisWeek()[0], endDate: utils_1.selectThisWeek()[1] },
    LAST_WEEK: { label: 'Last week', startDate: utils_1.selectLastWeek()[0], endDate: utils_1.selectLastWeek()[1] },
    THIS_MONTH: {
        label: 'This month',
        startDate: utils_1.selectThisMonth()[0],
        endDate: utils_1.selectThisMonth()[1],
    },
    LAST_MONTH: {
        label: 'Last month',
        startDate: utils_1.selectLastMonth()[0],
        endDate: utils_1.selectLastMonth()[1],
    },
    THIS_YEAR: { label: 'This year', startDate: utils_1.selectThisYear()[0], endDate: utils_1.selectThisYear()[1] },
    LAST_YEAR: { label: 'Last year', startDate: utils_1.selectLastYear()[0], endDate: utils_1.selectLastYear()[1] },
};
var DEFAULT_DATE_PRESETS = Object.values(exports.DatePresets);
var CustomSideContainer = function (_a) {
    var updateDates = _a.updateDates, maxDate = _a.maxDate, minDate = _a.minDate, _b = _a.datePresets, datePresets = _b === void 0 ? DEFAULT_DATE_PRESETS : _b;
    return datePresets.length ? (react_1.jsx(layout_1.Flex, { direction: "column", gap: 4, css: styles_1.style.customSideContainer }, datePresets.map(function (datePreset) {
        var disableOption = datePreset.disabled ||
            (minDate && datePreset.startDate < minDate) ||
            (maxDate && datePreset.endDate > maxDate);
        return (react_1.jsx("div", { css: [styles_1.style.sideText, disableOption ? styles_1.style.disabled : undefined], onClick: !disableOption
                ? function () { return updateDates(datePreset.startDate, datePreset.endDate); }
                : undefined, key: datePreset.label },
            react_1.jsx(Text_1.default.Body, { color: disableOption ? "var" + variables_1.TextColor.DISABLED : style_1.DesignSystemThemeColor.Gray.DARK_4, css: !disableOption && styles_1.style.label }, datePreset.label)));
    }))) : null;
};
exports.default = CustomSideContainer;
